<template>
  <div class="dash Header">
    <a-breadcrumb>
      <a-breadcrumb-item
      v-for="page in pages"
      :key="page.name">
        <router-link :to="page.route">{{page.name}}</router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <a-divider>
      <h2 v-html="dashboardTitle"  :style="{ textTransform: 'capitalize' }"></h2>
    </a-divider>
  </div>
</template>
<script>
export default {
  name: 'dash-header',
  props: [
    'pages',
    'dashboardTitle',
  ],
};
</script>
<style scoped>
.ant-breadcrumb a {
  text-transform: capitalize;
}
</style>
